<template>
  <div class="about-wraper">
        <Header></Header>
        <div class="about" v-if="data.content" v-html="data.content">

        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header'
import Footer from '@/components/Footer/Footer'
export default {
    name:"About",
    components:{
        Header,
        Footer
    },
    data(){
        return{
            id:'',
            data:{}
        }
    },
    created(){
        this.id = this.$route.params.id;
        this.getAboutInfo()
    },
     methods:{
         async getAboutInfo(){
             var result = await this.$http.home.getFootsByID({
                    footsID:this.id
             })
             console.log(result)
             if(result.code == 200){
                 this.data = result.data;
             }
         }
   },
   watch:{
       $route: {
          handler() {
              this.id = this.$route.params.id;
              this.getAboutInfo();
              
        },
        deep: true,
    }
   }


}
</script>

<style lang="less">
    .about{
        padding: 10px;
        img{
            width: 100% !important;
            }
    }
</style>